<p class="status-text">{{ statusText }}</p>
<cs-scanner-progress-bar [progress]="progress"></cs-scanner-progress-bar>
@if (retryMessage) {
  <p class="retry-message">{{ retryMessage }}</p>
}
